export const ResourcePages = {
  COLLEGE: 'College',
  LIFE_READINESS: 'Life Readiness',
  EMPLOYER: 'Employer',
  CAREER_PATH: 'Career Path',
  INTERNSHIP: 'Job Opportunity',
} as const;

export type ResourcePagesType = (typeof ResourcePages)[keyof typeof ResourcePages];
